module.exports = __webpack_public_path__ + "static/media/lease-option-1.0fb44042.jpg";